// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const creditCardMask = (value: string) => {
    let newValue = value.replace(/\D/g, "");

    newValue = newValue.replace(/(\d{4})(?=\d)/g, "$1 ");

    return newValue;
};
